<template>
  <div class="paymant-choice">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div class="card">
      <div class="p-col-12">
        <Toast />
        <h2>Choose payment option</h2>

        <Card>
          <div slot="title">
            <div class="title">{{ selected_package.name }}</div>
            <div class="price">{{ formatPrice(calculated_price) }} EUR</div>
          </div>
          <div slot="content">
            <div v-if="voucher">
              <div v-if="voucher.label">
                voucher "{{ voucher.label }}" applied
              </div>
              <div v-if="voucher.discount_pct">
                discount percentage:{{ voucher.discount_pct }}% applied
              </div>
              <div v-else-if="voucher.discount_abs">
                discount €: {{ voucher.discount_abs }} applied
              </div>
              <div v-if="voucher.upgrade_range">rank upgrade unlocked!</div>
            </div>
          </div>

          <div slot="content">
            <div class="card-package-body">
              <div
                class="description-item"
                v-for="desc in formatDescription(selected_package.description)"
                :key="desc"
              >
                <span class="check-icon pi pi-check"></span>
                <span class="text">{{ desc }}</span>
              </div>
            </div>
          </div>
          <!-- <div slot="footer">{{selected_package.description}}</div> -->
        </Card>

        <div class="card-options">
          <div class="">
            <div v-for="payment of payments" :key="payment.code" class="p-field-radiobutton payment_options form-item">
              <RadioButton :id="payment.code" name="payment" :value="payment" v-model="selected_payment" />
              <label class="p-radiobutton-label" :for="payment.code">{{payment.type}}
                <div v-if="payment.code == 'CC'" style="display:inline-block">
                  <img id="master" class="card_logo" src="assets/layout/images/pp/1.png" alt="Maestro" />
                  <img id="master" class="card_logo" src="assets/layout/images/pp/2.png" alt="Maestro" />
                  <img id="master" class="card_logo" src="assets/layout/images/pp/3.png" alt="Maestro" />
                  <img id="master" class="card_logo" src="assets/layout/images/pp/10.png" alt="Maestro" />
                  <img id="amex" class="card_logo" src="assets/layout/images/pp/22.png" alt="Maestro" />
                  <!-- 1 2 3 10 22 -->
                </div>
              </label>
              
            </div>
            <Button
              @click="openPaymentDetails()"
              :disabled="buttonDisable"
              label="Bank Wire payment details"
            />
            <!-- <Dropdown
              v-model="selected_payment"
              :options="payments"
              optionLabel="type"
              placeholder="Choose payment"
            /> -->
            <!-- <SelectButton v-model="selected_payment" :options="payments" optionLabel="type" /> -->
          </div>
          <div class="sb-option sb-option2">
            <InputText placeholder="Voucher" v-model="voucherlabel" />
            <Button
              @click="applyVoucher()"
              :disabled="buttonDisable"
              label="Add voucher"
              style="margin-left: 20px"
            />
          </div>

          <div class="sb-option sb-option4">
            <Button
              @click="addPurchase()"
              :disabled="buttonDisable"
              label="Add purchase"
            />
            <Button
              @click="gotoPackages()"
              :disabled="buttonDisable"
              label="Return to packages"
            />
          </div>

          <!-- <div class="sb-option sb-option3">
                        <Button @click="gotoPackages()" :disabled="buttonDisable" label="Return to packages" />
                    </div> -->
        </div>

        <!-- <div name="p-messages" type="div">
                  <Toast />
                  <Message
                    :severity="messages.severity"
                    :closable="true"
                    :life="1000"
                    :sticky="false"
                  >{{messages.content}}</Message>
                </div> -->
      </div>
      <div class="frametemplate"></div>
      <form
        id="pprocessor"
        method="post"
        action="https://test-wallet.corvuspay.com/checkout"
        target="_self"
      >
        <input type="hidden" name="store_id" v-model="corvus.store_id" />
        <input
          type="hidden"
          name="order_number"
          v-model="corvus.order_number"
        />
        <input type="hidden" name="language" v-model="corvus.language" />
        <input type="hidden" name="currency" v-model="corvus.currency" />
        <input type="hidden" name="amount" v-model="corvus.amount" />
        <input type="hidden" name="cart" v-model="corvus.cart" />
        <input type="hidden" name="signature" v-model="corvus.signature" />
        <input
          type="hidden"
          name="require_complete"
          v-model="corvus.require_complete"
        />
        <input type="hidden" name="version" v-model="corvus.version" />
      </form>
    </div>

    <Dialog
      header="Confirm payment"
      :visible.sync="dialog.purchase"
      :style="{ width: '50vw' }"
      :modal="true"
      :closable="false"
    >
      <h3>Complete payment: {{ selected_payment.type }}</h3>

      <!-- bank -->
      <div v-if="selected_payment.code == 'BNK'">
        <div>
          <p>
            To continue with the purchase please click "CONFIRM" and find the
            necessary information under Download area called
            <strong style="text-decoration: underline"
              >Wealth Net Bank Details</strong
            >.
          </p>
          <p>
            Your client ID (Use for Bankwire transfer):
            {{ $store.state.currentUser.id }}
          </p>
        </div>
        <br />

        <div class="p-grid">
          <div class="p-col-12 p-md-6">
            <label
              >Payment amount: {{ formatCurrency(calculated_price) }}
            </label>
            <!-- <InputText placeholder="Price" v-model="calculated_price"/> -->
          </div>
          <div class="p-col-12 p-md-6">
            <label> Package: {{ selected_package.name }} </label>
          </div>
        </div>
      </div>
      <!-- crypto -->

      <div v-if="selected_payment.code == 'CRY'">
        <div>
          <p>
            To continue with the purchase please click "CONFIRM" and continue to our payment provider
          </p>
          <p>
            Your client ID:
            {{ $store.state.currentUser.id }}
          </p>
        </div>
        <br />
        <div class="p-grid p-col-12">
            <div class="p-lg-6">
              <label
                >Payment amount:
                {{ parseFloat((calculated_price / btcPrice).toFixed(8)) }} BTC
              </label>
            </div>
            <div class="p-lg-6">
              <label> Package: {{ selected_package.name }} </label>
            </div>
          </div>
      </div>

      <!-- cash -->

      <div v-if="selected_payment.code == 'CSH'">
        <div>
          <h4>
            In order to complete the payment, please pay the amount to our
            personell in cash
          </h4>
          <h4>
            After the payment has been received, your purchase will be approved.
          </h4>
        </div>
        <br />

        <div class="p-grid">
          <div class="p-col-12 p-md-6">
            <label>Payment amount: {{ calculated_price }} </label>
            <!-- <InputText placeholder="Price" v-model="calculated_price"/> -->
          </div>
          <div class="p-col-12 p-md-6">
            <label> Package: {{ selected_package.name }} </label>
          </div>
        </div>
      </div>

      <!-- credit card -->

      <div v-if="selected_payment.code == 'CC'">
        <div>
          <p>
            To continue with the purchase please click "CONFIRM" and fill out
            your credit card data.
          </p>
          <p>
            Your client ID:
            {{ $store.state.currentUser.id }}
          </p>
        </div>
        <br />

        <div class="p-grid">
          <div class="p-col-12 p-md-6">
            <label
              >Payment amount: {{ formatCurrency(calculated_price) }}
            </label>
            <!-- <InputText placeholder="Price" v-model="calculated_price"/> -->
          </div>
          <div class="p-col-12 p-md-6">
            <label> Package: {{ selected_package.name }} </label>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="p-grid">
          <div class="p-md-6 p-offset-6">
            <Button
              label="Confirm"
              @click="open()"
              icon="pi pi-check"
              class="p-button-success"
            />
            <Button
              label="Cancel"
              @click="close()"
              icon="pi pi-times"
              class="p-button-danger"
            />
          </div>
        </div>
      </template>
    </Dialog>

    <Dialog
      header="Credit card data"
      :visible.sync="dialog.stripe"
      :style="{ width: '50vw' }"
      :modal="true"
      :closable="false"
    >
      <div id="stripe-form">
        <!-- Display a payment form -->
        <!--Stripe.js injects the Card Element-->
        <div id="card-element"></div>
      </div>
      <template #footer>
        <div class="p-grid">
          <div class="p-md-6 p-offset-6">
            <Button
              label="Confirm"
              @click="submitStripePayment()"
              icon="pi pi-check"
              class="p-button-success"
              :disabled="dialog.stripeCCValidated"
            />
            <Button
              label="Cancel"
              @click="closeStripe()"
              icon="pi pi-times"
              class="p-button-danger"
            />
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import PackageService from "../../service/PackageService";
import PurchaseService from "../../service/PurchaseService";
import PowercashService from "../../service/Powercash21Service";
import StripeService from "../../service/StripeService";
import CoinPaymentsService from "../../service/CoinPaymentsService";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      payments: [
        { type: "Cash", code: "CSH" },
        { type: "Bank transfer", code: "BNK" },
        { type: "Bitcoin", code: "CRY" },
        { type: "Credit Card", code: "CC" },
      ],
      voucherlabel: null,
      voucher: null,
      bankAccount: null,
      walletAddress: null,
      transactionHash: null,
      selected_payment: null,
      calculated_price: null,
      selected_package: this.$store.state.currentUser.selected_package,
      messages: { show: false, severety: null, content: null },
      buttonDisable: false,
      isLoading: false,
      walletEmpty: true,
      transactionHashEmpty: true,
      btcPrice: 0,
      dialog: {
        purchase: false,
        step: 1,
        stripe: false,
        stripeCCValidated: false,
      },
      corvus: {
        store_id: "12999",
        order_number: "1337",
        language: "hr",
        currency: "HRK",
        amount: "10.00",
        cart: "order256",
        signature:
          "382b1eb82786b87d2bc034e11788d314ca241a52d2f6c212d1866c29789bb4d0",
        require_complete: "false",
        version: "1.3",
      },
      stripe: null,
      stripeIntent: null,
      order: null,
      card: null,
    };
  },
  components: {
    Loading,
  },

  mounted() {
    //ovo je kao da ga staviš kao tag unutar head taga
    // var stripeScript = document.createElement("script");
    // stripeScript.setAttribute("src", "https://js.stripe.com/v3/");
    // document.head.appendChild(stripeScript);
    this.stripe = window.Stripe(
      "pk_live_51Hb8WLBbQWTOKEswarNu1zePjVfjwgCG099ctd9gvJET6vlT7gy0UhcSqm1xShorIQAwchvCZodERz3AjhGYADPi00UwO3u6YN"
    );
  },
  created() {
    this.packageService = new PackageService();
    this.purchaseService = new PurchaseService();
    this.powercashService = new PowercashService();
    this.stripeService = new StripeService();
    this.coinPaymentsService = new CoinPaymentsService();

    this.selected_payment = this.payments[1];
    this.calculated_price = this.selected_package.price;
    console.log(this.selected_package);
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    gotoPackages() {
      this.$router.push({
        name: "shop",
      });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    crySteps(step) {
      this.dialog.step = step;
    },
    walletChange() {
      if (this.walletAddress.length >= 26) {
        this.walletEmpty = false;
      } else {
        this.walletEmpty = true;
      }
      //console.log('test');
    },

    transactionChange() {
      if (this.transactionHash.length == 64) {
        this.transactionHashEmpty = false;
      } else {
        this.transactionHashEmpty = true;
      }
      //console.log('test');
    },

    async applyVoucher() {
      if (!this.voucherlabel) {
        this.$toast.add({
          severity: "warn",
          summary: "Please insert voucher",
          detail: "invalid voucher",
          life: 3000,
        });

        return;
      }
      var res = await this.purchaseService.getVoucher(this.voucherlabel);

      if (!res.data) {
        console.log("ulaz1");
   
        this.$toast.add({
          severity: "error",
          detail: "Invalid voucher",
          life: 3000,
        });

        return;
      }

      this.voucher = res.data;
      if (this.voucher.discount_pct) {
        this.calculated_price =
          this.selected_package.price -
          (this.voucher.discount_pct / 100) * this.selected_package.price;
      }

      if (this.voucher.discount_abs) {
        this.calculated_price =
          this.selected_package.price - this.voucher.discount_abs;
      }
    },

    async addPurchase() {
      if (this.selected_payment.code == "BNK") {
        this.walletEmpty = false;
        this.transactionHashEmpty = false;
      }
      if (this.selected_payment.code == "CSH") {
        this.walletEmpty = false;
        this.transactionHashEmpty = false;
      }

      if (this.selected_payment.code === "CRY") {
        this.walletEmpty = true;
        this.transactionHashEmpty = true;
        var temp = await this.purchaseService.getBTCEURPrice();
        console.log(temp);
        this.btcPrice =
          parseFloat(temp.data.bid) - 0.03 * parseFloat(temp.data.bid);
        console.log("btcprice");
        console.log(this.btcPrice);
      }

      if (this.selected_payment.code == "CC") {
        this.walletEmpty = false;
        this.transactionHashEmpty = false;
      }

      this.buttonDisable = true;
      this.dialog.purchase = true;
    },

    openWindowWithPost() {},
    addMessages() {
      this.messages = {
        severity: "success",
        content: "Payment successful",
        show: true,
      };
    },
    removeMessages() {
      this.messages = { severity: "", content: "", show: false };
    },
    close() {
      this.buttonDisable = false;
      this.dialog.purchase = false;
      this.buttonDisable = false;
      this.dialog.step = 1;
    },
    async open() {
      this.isLoading = true;
      this.buttonDisable = false;

      try {
        this.order = await this.purchaseService.addPurchase(
          //TODO - refactor
          this.$store.state.currentUser.id,
          this.selected_package.id,
          this.voucher ? this.voucher.id : null,
          this.$store.state.currentUser.token,
          this.selected_payment.code,
          this.bankAccount,
          this.walletAddress,
          this.selected_payment.code === "CRY"
            ? parseFloat(this.btcPrice.toFixed(8))
            : null,
          this.transactionHash
        );
      } catch (error) {
        console.log(error);
        return;
      }
      this.close();
      console.log(this.order);

      switch (this.selected_payment.code) {
        case 'CC':
          this.isLoading = false;
          this.dialog.stripe = true;
          this.submitStripeIntent();
          break;

        case 'CRY': {

          const transaction = await this.coinPaymentsService.createTransaction(this.order, this.$store.state.currentUser.email, this.$store.state.currentUser.username, this.selected_package.name)

          // window.open(transaction.checkout_url, '_blank')
          this.isLoading = false;
          // this.openMyPurchases()
          this.$router.push({ name: "payment_confirm" , query: { purchase_id: this.order }});
          break;
        }
      
        default:
          this.$toast.add({
            severity: "success",
            summary: "Payment successful", 
            life: 3000,
          });
          this.openMyPurchases()
          break;
      }
    },



    formatDescription(desc) {
      let points = desc.split(", ");

      return points;
    },

    powercash21payment() {
      try {
        //idući komentar je pcash21
        /*var userip = "";
          await fetch("https://api.ipify.org?format=json")
            .then((x) => x.json())
            .then(({ ip }) => {
              userip = ip;
            });

          console.log("pocinje log");
          console.log(userip);
          console.log(order);

          var pcash21 = document.getElementById("pprocessor");

          //await pcash21.submit();
          var ret = await this.powercashService.initPayment(
            order,
            this.calculated_price,
            userip
          );
          console.log(ret);
          var params = new URLSearchParams(ret);
          console.log(params.get("errorcode"));
          console.log(params.get("start_url"));
          console.log(params);

          if (params.get("errorcode") == 0 && params.get("start_url")) {
            var win = window.open(
              params.get("start_url") ||
                process.env.VUE_APP_FRONT_URL + "user/cc/payment_fail",
              "_self"
            );
            // win.focus();
          } else {
            throw new Error(params.get("errormessage"));
          }*/
      } catch (error) {
        console.log(error);
        this.$router.push({ name: "cc_payment_fail" });
        return;
      }
    },

    async submitStripeIntent() {
      try {
        this.stripeIntent = await this.stripeService.createPaymentIntent(
          this.order
        );

        var elements = this.stripe.elements();
        console.log(elements);

        var style = {
          base: {
            color: "#32325d",
            fontFamily: "Arial, sans-serif",
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
              color: "#32325d",
            },
          },
          invalid: {
            fontFamily: "Arial, sans-serif",
            color: "#fa755a",
            iconColor: "#fa755a",
          },
        };

        this.card = elements.create("card", { style: style , hidePostalCode: true});

        // Stripe injects an iframe into the DOM
        this.card.mount("#card-element");

        this.card.on("change", function (event) {
          console.log(event)
        });
        // Complete payment when the submit button is clicked
      } catch (error) {
        this.$router.push({ name: "cc_payment_fail" });
        return;
      }
    },
    async submitStripePayment() {
      this.isLoading = true
      var res = await this.stripe.confirmCardPayment(
        this.stripeIntent.clientSecret,
        {
          payment_method: {
            card: this.card,
          },
        }
      );
      console.log(res)
       this.isLoading = false
      if (res.error) {
        this.$toast.add({
          severity: "error",
          summary: res.error.message,
          detail: "invalid card",
          life: 5000,
        });
      } else if(res.paymentIntent.status=='succeeded'){
        this.$toast.add({
          severity: "info",
          summary: 'Payment success',
          life: 3000,
        });
        this.closeStripe()
        this.$router.push({ name: "cc_payment_success" });
        
      }
    },
    closeStripe() {
      this.dialog.stripe = false;
    },

    openPaymentDetails() {
      window.open('https://wealth-net.ag:3000/admin/Wealth%20Net%20-%20Payment%20Details%20v2.pdf', '_blank')
    },

    openMyPurchases() {
      var self = this;
          setTimeout(function () {
            self.$router.push({
              name: "user_purchases",
            });
          }, 1000);
    }
  },
};
</script>

<style scoped>
.sb-option {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  margin-top: 24px;
}

.sb-option2 {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  margin-top: 24px;
}

.sb-option3 {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-top: 24px;
}

.sb-option4 {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-top: 24px;
  margin-left: 20px;
}

.paymant-choice .card-options button.p-button {
  height: 3rem;
}

/* Variables */
.hidden {
  display: none;
}

#card-element {
  border-radius: 4px 4px 0 0;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  width: 100%;
  background: white;
}

#payment-request-button {
  margin-bottom: 32px;
}

.payment_options {
  margin: 7px;
  height: 2rem;
}
</style>